import { tcgplayerProvider } from './providers/tcgplayer';

const PROVIDERS = {
    [tcgplayerProvider.id]: tcgplayerProvider,
};

export function getProvider(id) {
    return PROVIDERS[id] || null;
}

export function listProviders() {
    return Object.values(PROVIDERS);
}

export function listProvidersFor(capability) {
    return listProviders().filter((p) => p.capabilities?.[capability]);
}
